import router from '../../routs/router';
import { store } from '../index';

export default {
  state: () => ({
    data: {
      isPairSelected: false,
    },
  }),
  mutations: {
    'product/setState'(state, payload) {
      state.data = {
        ...payload,
        isPairSelected: state.data?.isPairSelected,
      };
    },
    'product/changeSizeTab'(state, payload) {
      state.data.product.sizesTable = state.data.product.sizesTable.map((el) => ({
        ...el,
        active: el.id === payload,
      }));
      // console.log(state, payload);
    },
    'product/selectPair'(state, payload) {
      state.data = {
        ...state.data,
        isPairSelected: payload,
      };
    },
  },
  actions: {
    async 'product/getPageData'({ commit }, { url, changeUrl }) {
      try {
        commit('global/loaderStart');

        const { data, status } = await axios.get(url, { params: { api: 'y' } });

        if (status !== 200) {
          throw `bad request response ${payload}?api=y \n status: ${status}`;
        }

        // if (data.breadcrumbs) {
        //     store.commit('store/setResultsStore', { name: 'breadcrumbs', value: data.breadcrumbs });
        // }
        if (data.stores) {
          store.commit('stores/setState', data.stores);
        }
        commit('product/setState', data);

        if (changeUrl) {
          router.replace(url);
        }

        return true;
      } catch (err) {
        console.error(err);
      } finally {
        commit('global/loaderStop');
      }
    },
    async 'product/updatePageData'({ commit }, payload) {
      try {
        commit('global/loaderStart');

        const params = { api: 'y', ...payload };

        const { data, status } = await axios.get(location.href, { params: params });

        if (status !== 200) {
          throw `bad request response ${payload}?api=y \n status: ${status}`;
        }

        commit('product/setState', data);
        return true;
      } catch (err) {
        console.error(err);
      } finally {
        commit('global/loaderStop');
      }
    },
    async 'product/changeQuantity'({ commit, state }, payload) {
      try {
        commit('global/loaderStart');
        const url = payload?.url || state?.data?.product?.detailPage;
        const quantity = payload?.quantity;
        const { data: responseData, status } = await axios.get(url, {
          params: { api: 'y', quantity },
        });

        if (status === 200) {
          commit('product/setState', responseData);
        }

        return responseData;
      } catch (err) {
        console.error(err);
      } finally {
        commit('global/loaderStop');
      }
    },
  },
  getters: {
    'product/id': ({ data: { product } }) => product?.offer?.id || product?.id,
    'product/activeSize': ({ data: { product } }) => {
      const SIZES = product?.skuMatrix?.SIZES?.items;

      if (SIZES) {
        return SIZES?.find((el) => el.active);
      }
    },
    'product/isAvailable': (state) => (payload) => {
      const product = payload ?? state?.data?.product;
      if (product?.offer) return product?.offer?.isAvailable;
      return product?.isAvailable;
    },
  },
};
